import { ERROR_SERVER, SET_PERSONS_TO_VISIT, GET_PERSONS_TO_VISIT, IS_FETCHING, CLEAN } from "./types";

const AccessPersonToVisitReducer = (state, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_PERSONS_TO_VISIT:
            return {
                ...state,
                accessPersonsToVisit: payload.peopleToVisit,
                totalPages: payload.totalPages,
                error: false,
                message: '',
                isFetching: false,
            };
        case ERROR_SERVER:
            return {
                ...state,
                error: true,
                isFetching: false,
                message: payload,
            };
        case SET_PERSONS_TO_VISIT:
            return {
                ...state,
                accessPersonsToVisitSelected: payload,
            };
        case IS_FETCHING:
            return {
                ...state,
                isFetching: true,
            };
        case CLEAN:
            return {
                accessPersonsToVisit: [],
                totalPages: 1,
                isFetching: true,
                error: false,
                message: '',
                accessPersonsToVisitSelected: [],
            };
        default:
            return state;
    }
}

export default AccessPersonToVisitReducer